import { getExpandColumn } from '@global-dax-ad-platform/dax-components';
import { createColumnHelper } from '@global-engineering-shared/gweb-material-lab';
import { ColumnDef } from '@global-engineering-shared/gweb-material-types';
import { useMemo } from 'react';

import StatusMessage from 'components/StatusMessage';
import { getEntityIcon } from 'features/Entity/components/EntityActionBar/utils/getEntityIcon';
import EntityDetailValue from 'features/EntityDetails/components/EntityDetails/EntityDetail/components';
import { EntityType } from 'types/entityType';
import { TLinkedAssetFramesTableEntity } from 'types/tableEntityType';
import { LinkedAssetFrameStatus } from 'utils/statuses';

const useLinkedFramesDetailTableColumns = (
  includeStatus: boolean = false
): ColumnDef<TLinkedAssetFramesTableEntity>[] => {
  const columnHelper = useMemo(() => createColumnHelper<TLinkedAssetFramesTableEntity>(), []);

  const baseColumns: ColumnDef<TLinkedAssetFramesTableEntity, any>[] = [
    columnHelper.display(
      getExpandColumn({
        enableStatusBorder: false,
      })
    ),
    {
      id: 'entityType',
      header: '',
      accessorKey: 'entityType',
      size: 40,
      cell: () => getEntityIcon(EntityType.LINKED_ASSET_FRAME),
    },
    {
      id: 'spaceId',
      header: 'id',
      accessorKey: 'spaceId',
      size: 104,
    },
    {
      id: 'name',
      header: 'linked frame name',
      accessorKey: 'name',
      size: 225,
      meta: {
        getBodyCellProps: () => {
          return {
            style: {
              width: '100%',
            },
          };
        },
      },
      cell: (context) => (
        <EntityDetailValue
          label="Name"
          value={context.row.original.name.current}
          previousValue={context.row.original.name.previous}
          isBold={context.row.getIsExpanded()}
          variant="body2"
        />
      ),
    },
  ];

  if (includeStatus) {
    baseColumns.push({
      id: 'status',
      header: 'status',
      accessorKey: 'status',
      size: 100,
      cell: (context) => (
        <StatusMessage
          status={context.getValue() as LinkedAssetFrameStatus}
          isExpanded={context.row.getIsExpanded()}
        />
      ),
    });
  }

  return baseColumns;
};

export default useLinkedFramesDetailTableColumns;
